{#if isMatch}

<slot />

{#if component}

<svelte:component this={component} {...props} />

{/if}

{/if}

<script>
    const regexPattern = '([a-zA-Z0-9-_]+)'

    const prepExpression = (path, exact) => {
        const prefix = path.startsWith('/') ? '/' : ''
        const postfix = '\\/?'
        const preppedSegments = path.split('/').filter(Boolean).map((segment) => {
            if (segment.startsWith(':')) {
                return regexPattern
            }
            return segment
        })

        let expressionString = prefix + `${preppedSegments.join('\\/')}` + postfix
        
        if (!exact) expressionString = expressionString + '.*'
        
        return new RegExp(`^${expressionString}$`)
    }

    const prepParameters = (path) => {
        return path.split('/').filter((segment) => {
            return segment.startsWith(':')
        }).map((segment) => {
            return segment.slice(1)
        })
    }

    const matchRoute = (pathname, path, exact, props) => {
        const parameterNames = prepParameters(path)
        const expression = prepExpression(path, exact)
        // let props = {}
        let isMatch = false

        const matches = pathname.match(expression)
        
        if (matches) {
            isMatch = true

            parameterNames.forEach((paramaterName, index) => {
                const groupIndex = index + 1
                props[paramaterName] = matches[groupIndex]
            })
        }

        return {
            isMatch,
            props
        }
    }    

    export default {
        oncreate() {
            // update state on location change
            const history = window.customHistory
            const component = this
            const { path, exact, props } = this.get()
            
            history.listen((location) => {
                component.set({
                    ...matchRoute(location.pathname, path, exact, props)
                })
            })

            component.set({
                ...matchRoute(history.location.pathname, path, exact, props)
            })
		},
        data() {
            return {
                path: '',
                exact: true,
                component: null,
                props: {},
                isMatch: false
            }
        }
    }
</script>